// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Atom_Cta from "../../../atom/Atom_Cta.bs.js";
import * as Atom_Text from "../../../atom/Atom_Text.bs.js";
import * as Atom_Text_Ds from "../../../atom/Atom_Text_Ds.bs.js";

function Template_ProgramContent$Label(Props) {
  var label = Props.label;
  return React.createElement(Atom_Text.make, {
              children: label,
              style: Atom_Text_Ds.ProgramContent.makeLabel
            });
}

var Label = {
  make: Template_ProgramContent$Label
};

function Template_ProgramContent$Value(Props) {
  var value = Props.value;
  return React.createElement(Atom_Text.make, {
              children: value,
              style: Atom_Text_Ds.ProgramContent.makeValue
            });
}

function Template_ProgramContent$Value$Link(Props) {
  var value = Props.value;
  var href = Props.href;
  var onClick = Props.onClick;
  return React.createElement(Atom_Cta.Link.make, {
              href: href,
              label: value,
              onClick: onClick,
              style: /* ProgramMetaGenre */17
            });
}

var Link = {
  make: Template_ProgramContent$Value$Link
};

var Value = {
  make: Template_ProgramContent$Value,
  Link: Link
};

export {
  Label ,
  Value ,
}
/* react Not a pure module */
